import React from 'react';
import PortfolioDetail from '../features/portfolios/detail/portfolio-detail';

function PortfoliosDetailPage() {
  return (
    <div className='flex flex-col lg:flex-row w-full overflow-y-auto'>

      <div className='flex grow overflow-y-auto'>
        <PortfolioDetail />
      </div>

    </div>
  );
}

export default PortfoliosDetailPage;
